//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import list from './list.vue'

export default {
    components:{
        list
    },
    props: {

    },
    data () {
        return {
            type:'1',
            form:{
                kplx:0,
                yfpdm:'',
                yfphm:'',
                chyy:'',
            },
            loading:false,
        }
    },
    computed:{
        
    },
    watch:{
        'form.kplx':function(n,o){
            if(n !=o ){
                this.form.yfpdm = '';
                this.form.yfphm = '';
                this.form.chyy = '';
            }
        }
    },
    methods: {
        submitHandler:function(){
            let that = this;
            this.loading = true;
            this.$ajax({
                url: that.getStore('finUrl') + '/receipt/offlineInvoice',
                type: 'post',
                data: that.form,
                callback: (data, res) => {
                    ShowMsg.call(this, '开票成功', 'success');
                    that.cancleHandeler()
                },
                complete() {
                    that.loading = false;
                }
            });
        },
        cancleHandeler(){
            this.$emit('close');
        },
    },
    mounted: function() {
      
    }
}
